import React from 'react';

import { useHistory } from 'react-router-dom';
import { Container, Info, Cards } from './styles';
import NavBar from '../../../components/NavBar';
import Button from '../../../components/Button';

import Header from '../../../components/Header';

const Cadastros: React.FC = () => {
  const history = useHistory();

  return (
    <Container>
      <NavBar />
      <div id="page-wrap">
        <Header />
        <Info>
          <h1>Cadastros</h1>
          <br />
          <Cards>
            <Button onClick={() => history.push('/cadastros/classes')}>
              CLASSES
            </Button>
            <Button onClick={() => history.push('/cadastros/produtos')}>
              PRODUTOS
            </Button>
            <Button onClick={() => history.push('/cadastros/marcas')}>
              MARCAS
            </Button>
            <Button onClick={() => history.push('/cadastros/locais_producao')}>
              LOCAIS DE PRODUÇÃO
            </Button>
            <Button onClick={() => history.push('/cadastros/empresas')}>
              EMPRESAS
            </Button>
          </Cards>
        </Info>
      </div>
    </Container>
  );
};

export default Cadastros;
